function SessionChatAnswersCtrl() {
  this.searchAnser = "";
}

export { SessionChatAnswersCtrl };
